import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import Picture from '../../../@shared/picture';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import Icon from '../../../@shared/icon';
import { TBrochureCardProps } from '../../types/downloadBrochures.types';
import { iconSize } from '../../../../constants/icon.constants';
import '../../../../styles/@shared/product-card.scss';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import '../../../../styles/@shared/downloadBrochures/brochureCard/styles.scss';

const BrochureCard: FC<WithTranslation & TBrochureCardProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/camelcase
  const { title,alternateImageUrl, alternateText, digitalBrochureURL, filesize, publicLinks, downloadIcon, shareIcon, viewIcon } = props;
  const { t } = props;

  const productImageProps = alternateImageUrl
  ? {
      mobileRendition: { url: `${alternateImageUrl}&t=Size500` },
      desktopRendition: { url: `${alternateImageUrl}&t=Size500` },
      pictureClassName: 'brochure-card-article__picture brochure-card-article__picture--fixed-aspect-ratio',
      alt: alternateText,
    }
  : {
    mobileRendition: { url: `${publicLinks?.bigthumbnail}}&t=Size500` },
    desktopRendition: { url: `${publicLinks?.bigthumbnail}&t=Size500` },
    pictureClassName: 'download-brochure_card__article__picture--fixed-aspect-ratio',
    alt: alternateText,
  };

  return (
    <article className="download-brochure_card__article">
      <div className="download-brochure_card__image-container">
        <Picture productImageProps={productImageProps} />
      </div>

      <div className="download-brochure_card__content-block">
        {title ? <h2 className="download-brochure_card__title">{title}</h2> : null}
        {filesize ? <span className="download-brochure_card__sub-heading"> {filesize} MB </span> : null}
      </div>
      <div className="download-brochure_card__link-wrapper">
        {digitalBrochureURL ? (
          <RoutableNotEditableLink
          
            href={digitalBrochureURL}
            target="_blank"
            className={'download-brochure_card__link download-brochure_card__link--view'}
          >
            <span className="download-brochure_card__link download-brochure_card__link--label">
              <DictionaryTerm keyword="cnhi-view" />
            </span>
            {viewIcon && <Icon iconField={viewIcon} color="primary" extraClassName="download-brochure_card__link__icon" size={iconSize.dsk} />}
          </RoutableNotEditableLink>
        ) : (
          <div className="a2a_kit a2a_kit_size_32 a2a_default_style ">
            <a
              className="a2a_dd download-brochure_card__link download-brochure_card__link--share download-brochure_card__add-to-any"
              data-a2a-url={publicLinks?.downloadOriginal}
              data-a2a-title={alternateText}
            >
              <span role="button" className="download-brochure_card__link--label">
                {t('cnhi-share')}
              </span>
              {shareIcon && <Icon iconField={shareIcon} color={'primary'} size={iconSize.dsk} />}
            </a>
          </div>
        )}
        <RoutableNotEditableLink
          href={publicLinks?.downloadOriginal}
          target="_blank"
          className={'download-brochure_card__link download-brochure_card__link--download'}
        >
          <span className="download-brochure_card__link download-brochure_card__link--label">{t('cnhi-download')}</span>
          {downloadIcon && <Icon iconField={downloadIcon} color={'primary'} extraClassName="download-brochure_card__link__icon" size={iconSize.dsk} />}
        </RoutableNotEditableLink>
      </div>
    </article>
  );
};

export default withTranslation()(BrochureCard);
